import i18next, { type TFunction } from 'i18next'

/**
 * 英語のヘッダー名が spec で定義されていない CSV のヘッダー行に使う翻訳関数。
 * 表示言語に関わらず日本語の文言を返す。
 *
 * `conventions.md`「CSV の英語表示」: 「英語ヘッダー名・英語のファイル名（データ種別名）が
 * 未定義の CSV は、 定義されるまでヘッダー行・ファイル名を日本語で出力する」。画面の列名の
 * 訳語 (英語表示では英語) をそのまま CSV のヘッダーに使うと、spec に無い英語ヘッダーが
 * 出てしまうため、ヘッダーだけ日本語に固定する。区分値 (エリア等) は表示言語の値で出す。
 * 英語ヘッダー名が定義された CSV では使わない (その CSV の英語ヘッダー表を引く)。
 */
export function undefinedEnglishCsvHeaderT(): TFunction {
  return i18next.getFixedT('ja')
}
